import React from "react";
import {Box, Container} from "@mui/material";
import {Outlet} from "react-router-dom";

type OwnProps = {};

type Props = OwnProps;

const PublicTemplate: React.FC<Props> = props => {
    const {} = props;
    return (
        <Box mt={10}>
            <Container maxWidth="sm">
                <Box component="span" m={5} textAlign="center">
                    <Outlet/>
                </Box>
            </Container>
        </Box>
    )
}

export default PublicTemplate;
